import { jsx as _jsx } from "react/jsx-runtime";
import { mergeAttributes, Node } from '@tiptap/core';
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { useMemo } from 'react';
import { createNodeAdapter } from '../../node';
export function createTextBlockNode(config) {
    const { Component, blockContext: { Provider: BlockContextProvider }, } = config;
    const TiptapComponent = (props) => {
        const adapter = useMemo(() => createNodeAdapter(props), [props]);
        const viewProps = {
            id: props.node.attrs.tiptapNodeId ?? null,
            adapter,
        };
        return (_jsx(NodeViewWrapper, { as: "span", "data-block-id": props.node.attrs.blockId, "data-tiptap-node-id": props.node.attrs.tiptapNodeId, children: _jsx(BlockContextProvider, { value: { adapter }, children: _jsx(Component, { ...viewProps, children: _jsx(NodeViewContent, { as: "span" }) }) }) }));
    };
    return Node.create({
        name: 'textBlock',
        group: 'block',
        content: 'inline*',
        defining: true,
        draggable: true,
        addOptions() {
            return {
                HTMLAttributes: {},
            };
        },
        addAttributes() {
            return {
                blockId: {
                    default: null,
                    parseHTML: (element) => element.getAttribute('data-block-id'),
                    renderHTML: (attributes) => {
                        if (!attributes.blockId) {
                            return {};
                        }
                        return { 'data-block-id': attributes.blockId };
                    },
                },
            };
        },
        parseHTML() {
            return [
                {
                    tag: 'div[data-type="text-block"]',
                    getAttrs: (element) => {
                        if (element instanceof HTMLElement) {
                            return {
                                blockId: element.getAttribute('data-block-id'),
                            };
                        }
                        return false;
                    },
                },
            ];
        },
        renderHTML({ HTMLAttributes }) {
            return [
                'div',
                mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {}),
                0,
            ];
        },
        addCommands() {
            return {};
        },
        addNodeView() {
            return ReactNodeViewRenderer(TiptapComponent);
        },
    });
}
//# sourceMappingURL=textBlockExtension.js.map